const userProfiles = {
	none: 1,
	internalTranscriber: 2,
	freelanceTranscriber: 3,
	analyst: 4,
	superviser: 5,
	coordinator: 6,
	adminUser: 7,
};

export { userProfiles };
